import * as Yup from 'yup'

import { getValidator } from '../ProfileContactsWidgetListCell'

export function getHasPhoneContact(newContacts) {
  return newContacts.some(contact => contact.typeConfig.isPhone)
}

export function getValidationSchema({ name, newContacts, t }) {
  return Yup.object(
    newContacts.reduce((acc, contact) => {
      acc[contact.id] = Yup.object({
        [name]: getValidator({
          isCreate: false,
          t,
          typeConfig: contact.typeConfig,
        }),
      })

      return acc
    }, {})
  )
}
